// 基础类库，提供页面基本功能通过mixin 方式插入到该方法
import Vue from 'vue';
import taskMgr from '../../../task/taskMgr'
import {getQueryString} from '../../../util/util';
import { Toast } from 'vant';
import supreme from '../../../supreme'
export default{
  /**
   * @description  baseMinxin 一定要在vue组件中采用mixins 的方式使用，否则不用调用created 的方法
   * */
  created(){
    //this.query=this.$route.query;
    //没个页面入口index 自动生成一个单独事件bus
    this.hubus=new Vue();
    // 处理刷新浏览器以后回退引起的时序问题
    setTimeout(()=>{
      // 虽然解决了回退但是，无法判断首次页面加载时候

      if(!supreme._isPopState){
        taskMgr.fillVueComponentToTask(getQueryString("url_gid"),this);
      }

    });
    if(!this.$router){
      throw("缓存控制必须使用vue-router");
      // return ;
    }
  },
  methods:{
    initEvent(){
      supreme.pubHubus.$on('online',()=>{
        //console.log('this is online');
        Toast("网络状态恢复正常");
      });
      supreme.pubHubus.$on('offline',()=>{
        Toast("网络状态异常");
      });
    },
    lineStatus(on){
      if(!on){
        Toast("网络状态有问题")
      }
    }

  },
  deactivated(){
  },
  activated(){
    //处理当进入的页面是使用缓存的情况下如何做栈管理
    // 处理刷新浏览器以后回退引起的时序问题
    setTimeout(()=>{
      if(!supreme._isPopState&&getQueryString("isForward")){
        taskMgr.fillVueComponentToTask(getQueryString("url_gid"),this);
      }
    });


  },
  // 清除本页面缓存keep-alive缓存
  removeCache(){
    // console.log(this);
  },
  beforeRouteLeave(to,from ,next){
    //console.log('................beforeRouteEnter');
      /**
    if(to.query.clearCache){
      var useCache = eval(to.query.useCache);
      if(!useCache){
        //this.$options.parent.cache=[];
        var _uid=this._uid;
        this.$options.parent&&this.$options.parent.cache&&(()=>{
          for(var c in this.$options.parent.cache){
            var cache = this.$options.parent.cache[c];
            if(cache.componentInstance._uid==_uid){

              this.$options.parent&&this.$options.parent.keys&&(()=>{
                for(var i=0;i<this.$options.parent.keys.length;i++){
                  if(this.$options.parent.keys[i]==c){
                    this.$options.parent.keys.splice(i--,1);
                  }
                }
              })();

              delete this.$options.parent.cache[c];
            }
          }
        })();
      }
    }
    */
    next();
  }
}

